export default __webpack_public_path__ + "static/media/Background.50f5cad7.svg";